var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNofilesavailable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 252,
    viewBox: "0 0 309 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.629 153.095H101.451C96.1049 153.095 91.9043 148.767 91.9043 143.548V75.5745C91.9043 70.992 95.3412 67.1733 99.9236 66.6641L200.229 56.6081C205.83 56.099 210.667 60.4269 210.667 66.0277V144.184C210.54 149.149 206.466 153.095 201.629 153.095Z",
    fill: "#3361CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.15 252C239.284 252 308.299 227.494 308.299 197.265C308.299 167.035 239.284 142.53 154.15 142.53C69.0151 142.53 0 167.035 0 197.265C0 227.494 69.0151 252 154.15 252Z",
    fill: "url(#paint0_linear_1207_6918)",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174.059 116.487L125.434 129.852C120.597 131.125 115.633 128.325 114.36 123.488L97.3027 61.6243C96.0298 56.7872 98.8302 51.8229 103.667 50.55L152.292 37.0571C157.13 35.7842 162.094 38.5846 163.367 43.4216L180.424 105.285C181.697 110.122 178.896 115.087 174.059 116.487Z",
    fill: "#C9D7FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.621 63.0247L113.087 74.99C110.923 75.6265 108.632 74.3536 107.995 72.0623L106.595 66.7161C105.959 64.5522 107.232 62.2609 109.523 61.6245L153.056 49.6591C155.22 49.0227 157.512 50.2956 158.148 52.5868L159.548 57.933C160.185 60.097 158.784 62.3882 156.621 63.0247Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161.33 77.281L116.396 89.6283C114.614 90.1374 112.705 89.1191 112.196 87.2097C111.687 85.4277 112.705 83.5183 114.614 83.0091L159.548 70.6619C161.33 70.1527 163.24 71.1711 163.749 73.0804C164.258 74.8625 163.112 76.7719 161.33 77.281Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.276 91.7925L120.342 104.14C118.56 104.649 116.651 103.631 116.142 101.721C115.632 99.9391 116.651 98.0298 118.56 97.5206L163.494 85.1734C165.276 84.6642 167.185 85.6825 167.695 87.5919C168.204 89.374 167.185 91.2833 165.276 91.7925Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M133.019 5.43677L138.365 14.2199",
    stroke: "#5A83E7",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M175.28 5.43677L169.934 14.2199",
    stroke: "#5A83E7",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M154.15 2V12.1833",
    stroke: "#5A83E7",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M191.978 117.835L142.461 108.033C137.624 107.015 134.442 102.305 135.333 97.4683L147.808 34.4592C148.826 29.6222 153.536 26.4399 158.373 27.3309L207.889 37.1323C212.726 38.1507 215.908 42.8604 215.017 47.6975L202.543 110.707C201.652 115.671 196.815 118.853 191.978 117.835Z",
    fill: "#C9D7FA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M200.251 62.2086L155.954 53.4255C153.663 53.0436 152.263 50.7524 152.645 48.5884L153.663 43.2422C154.045 40.951 156.336 39.5508 158.5 39.9326L202.797 48.7157C205.088 49.0976 206.489 51.3888 206.107 53.5528L205.088 58.899C204.707 61.1903 202.543 62.7177 200.251 62.2086Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M198.087 77.1016L152.39 68.064C150.48 67.6821 149.335 65.9 149.717 63.9907C150.099 62.0813 151.881 60.9357 153.79 61.3176L199.488 70.3552C201.397 70.7371 202.543 72.5192 202.161 74.4285C201.779 76.3379 199.869 77.4835 198.087 77.1016Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M195.16 91.8673L149.463 82.8296C147.553 82.4477 146.408 80.6657 146.789 78.7563C147.171 76.8469 148.953 75.7013 150.863 76.0832L196.56 85.1208C198.47 85.5027 199.615 87.2848 199.233 89.1942C198.852 91.1035 197.069 92.2492 195.16 91.8673Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M203.284 153.095H100.815C95.3412 153.095 91.0133 148.131 91.9044 142.784L100.942 82.8302C101.578 78.375 105.397 75.0654 109.852 75.0654H212.194C217.795 75.0654 221.996 80.0298 221.232 85.5033L212.194 145.33C211.431 149.913 207.739 153.095 203.284 153.095Z",
    fill: "#5A83E7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1207_6918",
    x1: 154.15,
    y1: 142.53,
    x2: 154.15,
    y2: 208.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A83E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNofilesavailable);
export default __webpack_public_path__ + "static/media/No files available.20486486cbe01adb54b75f6bfa80139c.svg";
export { ForwardRef as ReactComponent };